export function getSearchFilter({
  searchData,
  authors,
  syncedFilterState,
}: {
  searchData: string;
  authors: any[];
  syncedFilterState: any;
}) {
  const enteredValueByUser = (searchData || "").trim().toLowerCase();
  let updatedFilter: any = { ...syncedFilterState.filter };

  const clean = (str: string) =>
    str.replace(/[.,/#!$%^&*;:{}=\-_`~()]/g, "").toLowerCase();
  const enteredWords = enteredValueByUser
    .split(/\s+/)
    .map(clean)
    .filter(Boolean);

  if (/^\d{13}$/.test(enteredValueByUser)) {
    updatedFilter.ISBN = enteredValueByUser;
    delete updatedFilter.searchString;
    delete updatedFilter.author;
    delete updatedFilter.parentCategoryIdList;
    return updatedFilter;
  }

  if (!enteredValueByUser) {
    delete updatedFilter.searchString;
    delete updatedFilter.author;
    delete updatedFilter.ISBN;
    delete updatedFilter.parentCategoryIdList;
    return updatedFilter;
  }

  if (enteredWords.length > 3) {
    updatedFilter.searchString = enteredValueByUser;
    delete updatedFilter.author;
    delete updatedFilter.ISBN;
    delete updatedFilter.parentCategoryIdList;
    return updatedFilter;
  }

  const authorMatch = authors.find((author: any) => {
    if (!author?.name) return false;
    const authorWords = author.name.split(/\s+/).map(clean).filter(Boolean);
    return enteredWords.every((word) => authorWords.includes(word));
  });

  if (authorMatch) {
    // updatedFilter.author = enteredValueByUser;
    updatedFilter.searchString = enteredValueByUser;
    delete updatedFilter.author;
    delete updatedFilter.ISBN;
    delete updatedFilter.parentCategoryIdList;
    return updatedFilter;
  }

  updatedFilter.searchString = enteredValueByUser;
  delete updatedFilter.author;
  delete updatedFilter.ISBN;
  delete updatedFilter.parentCategoryIdList;
  return updatedFilter;
}
